import React, { useState } from 'react';
import { Box, Card, CardContent, Grid, TextField, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, Chip, FormControl, InputLabel, Select, MenuItem, Tooltip, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { Download, Calculate, Refresh, FlightTakeoff } from '@mui/icons-material';
import { Restore as RestoreIcon, Edit as EditIcon } from "@mui/icons-material";
import { variableRentData, loanInputData } from '../data/mockData';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import '../styles/VariableRent.scss';
import '../styles/loanCommon.scss';
import LoanInputParameters from './LoanInputParameters';
import { trackActivity } from '../../../../utils/mixpanel';

const VariableRent = ({ loanType, onLoanTypeChange }) => {
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: 'Variable Rent', page_type: page_type })
    }

    const [scheduleData] = useState(variableRentData);
    const [inputData, setInputData] = useState({
        ...loanInputData,
    });
    const [error, setError] = useState({});
    const [openDialog, setOpenDialog] = useState({ modal: false });

    const onRestErrorKey = (key) => {
        setError((prev) => ({ ...prev, [key]: '' }));
    };

    const onFieldChange = (key, value) => {
        setInputData({ ...inputData, [key]: value });
        setError((prev) => ({ ...prev, [key]: '' }));
    };

    const handleCalculate = () => {
        alert('Calculation logic will be implemented');
    };

    const handleSaveVariableRent = () => {
        alert('Added successfully');
        setOpenDialog(false);
    };

    const handleExport = (format) => {
        alert(`Exporting schedule as ${format}`);
    };

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0
        }).format(amount);
    };

    const getUtilizationColor = (utilization) => {
        const value = parseInt(utilization);
        if (value >= 100) return 'error';
        if (value >= 95) return 'warning';
        return 'success';
    };

    return (
        <Box className="variable-rent-container">
            <Card className="input-form-card">
                <CardContent>
                    <Box className="table-header">
                        <Typography className='loan-heading'>Loan Input Parameters</Typography>
                        <Box className="export-buttons">
                            <Tooltip arrow title="Revision History"><RestoreIcon className="revision-history" sx={{ cursor: 'pointer' }} onClick={() => handleItemClicked('RevisionHistoryIcon')} fontSize='small' color='primary' /></Tooltip>
                            <Tooltip arrow title="Edit"><EditIcon sx={{ cursor: 'pointer' }} onClick={() => { setOpenDialog({ modal: true }); handleItemClicked('EditIcon') }} fontSize='small' color='primary' /></Tooltip>
                        </Box>
                    </Box>
                    <Grid container spacing={3}>
                        <LoanInputParameters inputData={inputData} handleInputChange={onFieldChange} loanType={loanType} onLoanTypeChange={onLoanTypeChange} type={'view'} />
                    </Grid>
                </CardContent>
            </Card>

            <Card className="table-card">
                <CardContent>
                    <Box className="table-header">
                        <Typography className='loan-heading'>Variable Rent Schedule (Utilization-Based)</Typography>
                        <Box className="export-buttons">
                            <Button startIcon={<ArrowDownwardIcon />} variant="outlined" size='small' onClick={() => handleItemClicked('Export Button')}> Export </Button>
                        </Box>
                    </Box>
                    <TableContainer component={Paper} className="variable-rent-table lease-detail-table">
                        <Table stickyHeader className="mui-table-format">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Month</TableCell>
                                    <TableCell>Date</TableCell>
                                    <TableCell align="right">Avg Flight Hours</TableCell>
                                    <TableCell align="right">Rate/Hour</TableCell>
                                    <TableCell align="right">Rent</TableCell>
                                    <TableCell align="right">Debt Service</TableCell>
                                    <TableCell align="right">Interest</TableCell>
                                    <TableCell align="right">Principal</TableCell>
                                    <TableCell align="right">Outstanding</TableCell>
                                    <TableCell align="center">Utilization</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {scheduleData.map((row) => (
                                    <TableRow key={row.month} hover>
                                        <TableCell>{row.month}</TableCell>
                                        <TableCell>{row.date}</TableCell>
                                        <TableCell align="right">{row.avgFlightHours}</TableCell>
                                        <TableCell align="right">{formatCurrency(row.ratePerHour)}</TableCell>
                                        <TableCell align="right">{formatCurrency(row.rent)}</TableCell>
                                        <TableCell align="right">{formatCurrency(row.debtService)}</TableCell>
                                        <TableCell align="right">{formatCurrency(row.interest)}</TableCell>
                                        <TableCell align="right">{formatCurrency(row.principalRepayment)}</TableCell>
                                        <TableCell align="right" className="outstanding-balance">
                                            {formatCurrency(row.principalOutstanding)}
                                        </TableCell>
                                        <TableCell align="center">
                                            <Chip
                                                icon={<FlightTakeoff />}
                                                label={row.utilization}
                                                color={getUtilizationColor(row.utilization)}
                                                size="small"
                                            />
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </CardContent>
            </Card>

            {openDialog?.modal ? <Dialog aria-labelledby="customized-dialog-title" className='add-lease-dialog' maxWidth='md' open={true}>
                <DialogTitle className='dialog-header'>Edit Varibale Rent</DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <LoanInputParameters type={'edit'} inputData={inputData} loanType={loanType} onLoanTypeChange={onLoanTypeChange} onRestErrorKey={onRestErrorKey} error={error}/>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { setOpenDialog({ modal: false }); handleItemClicked('Cancel Button') }} size='small'>Cancel</Button>
                    <Button onClick={() => { handleSaveVariableRent(); handleItemClicked('Save Button') }} variant="contained" color="primary" size='small'>Save</Button>
                </DialogActions>
            </Dialog> : null}
        </Box>
    );
};

export default VariableRent;

